export default "__VITE_ASSET__CUgJ7rXN__"